/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import { Dialog, DialogType } from "@fluentui/react";

// export interface IErrorDialogProps {
//     test: boolean
// }

export const ErrorDialog = (/*props : IErrorDialogProps*/): JSX.Element => {
    // const modalProps: IModalProps = {
    // }

    const dialogContentProps = {
        type: DialogType.normal,
        title: "Application Error",
        closeButtonAriaLabel: "Close",
        subText: "An unexpected error occurred in the application."
    };

    return <Dialog hidden={false} modalProps={dialogContentProps}></Dialog>;
};
